export const productIdMap = new Map<string, number>([
    ['cms', 1],
    ['claim', 1],
    ['admin', 1],
    ['client', 1],
    ['home', 1],
    ['user', 9]
  ])